<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-space-between"> 
                        <span>
                            <v-icon left>mdi-format-list-bulleted</v-icon>
                            Lista de Tratamientos
                        </span>
                        <v-btn color="primary" @click="handleAddTratamiento">
                            <v-icon left>mdi-plus</v-icon>
                            Nuevo Tratamiento
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!-- Filtros de busqueda -->
                        <v-row>
                            <v-col cols="12" md="8">
                                 <v-text-field
                                    label="Buscar por nombre"
                                    v-model="filtros.search"
                                    @keyup.enter="getData"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center gap-2">
                                <v-btn color="primary" @click="getData">Buscar</v-btn>
                                <v-btn color="secondary" @click="resetFilters">Limpiar</v-btn>
                            </v-col>
                        </v-row>


                        <v-data-table
                            :headers="table.headers"
                            :items="table.data.data"
                            :options.sync="table.options"
                            :items-per-page="table.options.itemsPerPage"
                            :server-items-length="table.data.total"
                            class="elevation-1"
                            @update:options="changeOptionsTable"
                        >
                            <template v-slot:item.idtratamiento="{ item }">
                                {{ formatCode(item.idtratamiento) }}
                            </template>

                            <template v-slot:item.nombre_imagen="{ item }">
                                <v-img
                                    v-if="item.nombre_imagen"
                                    :src="assetAWS(item.nombre_imagen)"
                                    width="100"
                                    height="50"
                                    contain
                                    class="bg-img-tenue"
                                />
                                <span v-else>Sin imagen</span>
                            </template>
                            <template v-slot:item.imagen="{ item }">
                                <v-img
                                    v-if="item.imagen"
                                    :src="assetAWS(item.imagen)"
                                    width="100"
                                    height="50"
                                    contain
                                    class="bg-img-tenue"
                                />
                                <span v-else>Sin imagen</span>
                            </template>
                            <template v-slot:item.icon_after_nombre="{ item }">
                                <v-img
                                    v-if="item.icon_after_nombre"
                                    :src="assetAWS(item.icon_after_nombre)"
                                    width="100"
                                    height="50"
                                    contain
                                    class="bg-img-tenue"
                                />
                                <span v-else>Sin imagen</span>
                            </template>


                            <template v-slot:item.estado="{ item }">
                                <v-chip :color="item.estado == 1 ? 'green' : 'red'" dark>
                                    {{ item.estado == 1 ? 'Activo' : 'Inactivo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.acciones="{ item }">
                                <div class="d-flex gap-2">
                                    <v-btn icon small color="primary" @click="handleEditTratamiento(item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon small color="red" @click="handleDeleteTratamiento(item)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>

                            </template>
                                        

                            <template v-slot:no-data>
                                No hay tratamientos para mostrar
                            </template>
                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <!-- Modal nuevo tratamiento -->
        <ModalCard
            v-model="modal.addTratamiento.show" 
            max-width="900px"
            @cancel="resetModal('addTratamiento')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Nuevo Tratamiento
            </template>

            <FormTratamiento
                class="p-form"
                v-model="modal.addTratamiento.tratamiento"
                @submit="handleStoreTratamiento"
                @cancel="resetModal('addTratamiento')"
            />
        </ModalCard>

        <!-- Modal editar tratamiento -->
        <ModalCard
            v-model="modal.editTratamiento.show" 
            max-width="900px"
            @cancel="resetModal('editTratamiento')"
            >
            <template #title>
                <v-icon left>mdi-pencil</v-icon>
                Editar Tratamiento #{{ formatCode(modal.editTratamiento.tratamiento?.idtratamiento || '') }}
            </template>

            <FormTratamiento
                class="p-form"
                v-model="modal.editTratamiento.tratamiento"
                @submit="handleUpdateTratamiento"
                @cancel="resetModal('editTratamiento')"
            />
        </ModalCard>

        <!-- Modal eliminar tratamiento -->
        <ModalDelete
            v-model="modal.deleteTratamiento.show" 
            @destroy="handleDestroyTratamiento"
            @cancel="resetModal('deleteTratamiento')"
        />
    </v-container>
</template>

<script >
    import tratamientoService from '@/services/tratamientoService';
    import { tratamiento } from '@/models/tratamiento';

    import ModalCard from '@/components/ModalCard.vue';
    import ModalDelete from '@/components/ModalDelete.vue';
    import FormTratamiento from '@/components/tratamientos/tratamiento/FormTratamiento.vue';

    const modals = _ => ({
        addTratamiento: {
            show: false,
            tratamiento: null,
        },
        editTratamiento: {
            show: false,
            tratamiento: null,
        },
        deleteTratamiento: {
            show: false,
            tratamiento: null,
        },
    })

    export default {
        name: "TratamientosModalIndex",
        components: {
            ModalCard,
            ModalDelete,
            FormTratamiento,
        },
        data() {
            return {
                resources: {
                },
                table: {
                    headers: [
                        { text: 'ID', value: 'idtratamiento' },
                        { text: 'Nombre', value: 'nombre' },
                        { text: 'Descripción', value: 'descripcion' },
                        { text: 'Nombre imagen', value: 'nombre_imagen' },
                        { text: 'Imagen', value: 'imagen' },
                        { text: 'Icono despues de nombre', value: 'icon_after_nombre' },
                        { text: 'Estado', value: 'estado' },
                        {
                            text: 'Acciones',
                            value: 'acciones',
                            align: 'center',
                            sortable: false,
                        }
                    ],
                    options: {
                        page: 1,
                        itemsPerPage: 15,
                        sortBy: [],
                        sortDesc: [],
                    },
                    data: {
                        data: [],
                        total: 0,
                    }

                },
                filtros: {
                    search: '',
                },
                modal: modals(),
            }
        },
        methods: {
            async getData() {

                const options = this.table.options;

                const page = options.page || 1;
                const perPage = options.itemsPerPage || 15;
                const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : null;
                const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
                const search = this.filtros.search || '';


                try {
                    const res = await tratamientoService.paginate({
                        page: page,
                        per_page: perPage,
                        search: search,
                        sort_by: sortBy,
                        sort_desc: sortDesc !== null ? (sortDesc ? 'desc' : 'asc') : null,
                    });
                    this.table.data = res.data;

                    
                } catch (error) {
                    console.error(error);
                }
            },

            changeOptionsTable(options) {
                this.table.options = options;
                this.getData();
            },


            resetOptionsTable() {
                this.table.options.page = 1;
                this.table.options.itemsPerPage = 15;
                this.table.options.sortBy = [];
                this.table.options.sortDesc = [];
            },

            resetFilters() {
                this.filtros.search = '';

                this.resetOptionsTable();
                this.getData();
            },


            handleAddTratamiento() {
                this.modal.addTratamiento.tratamiento = {...tratamiento };
                this.modal.addTratamiento.show = true;
            },
            handleEditTratamiento(tratamiento) {
                this.modal.editTratamiento.tratamiento = tratamiento;
                this.modal.editTratamiento.show = true;
            },
            handleDeleteTratamiento(tratamiento) {
                this.modal.deleteTratamiento.tratamiento = tratamiento;
                this.modal.deleteTratamiento.show = true;
            },

            async handleStoreTratamiento(form) {

                try {

                    const formData = new FormData();
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoService.store(formData);
                    
                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('addTratamiento');
                    this.$toasted.success('Tratamiento creado correctamente.');

                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleUpdateTratamiento(form) {
                try {
                    const formData = new FormData();
                    formData.append('_method', 'PUT');
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoService.update(form.idtratamiento, formData);
                    
                    await this.getData();
                    this.resetModal('editTratamiento');
                    this.$toasted.success('Tratamiento actualizado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleDestroyTratamiento() {
                try {
                    const tratamiento = this.modal.deleteTratamiento.tratamiento;

                    const formData = new FormData();
                    formData.append('_method', 'DELETE');
                    
                    await tratamientoService.destroy(tratamiento.idtratamiento, formData);

                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('deleteTratamiento');
                    this.$toasted.success('Tratamiento eliminado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },

            resetModal(modalName) {
                const modales = modals();

                if ( !modales.hasOwnProperty(modalName) ) {
                    console.warn(`El modal ${modalName} no existe.`);
                    return;
                }

                this.modal[modalName] = modales[modalName];
            }
        }
    }
</script>

<style scoped>
    .gap-2 {
        gap: 8px;
    }
</style>